import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { IResource } from '@/types/course.d';

@Component
export default class formMixin extends Vue {
  public form: IResource = {
    resourceSeq: 0,
    resourceTitle: '',
    resourceType: null,
    resourceUser: null,
    stepPid: '',
    ojQuestionPid: null,
  };

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: { [key: string]: Array<object> } = {
    resourceTitle: [
      { required: true, message: '标题不能为空' },
    ],
    resourceType: [
      { required: true, message: '类型不能为空' },
    ],
    resourceUser: [
      { required: true, message: '使用者不能为空' },
    ],
    resourceSeq: [
      { required: true, message: '排序不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
